import styled from '@emotion/styled';

export const Wrapper = styled.form``;
